
<!--此页面为显示 没有购买课程-->
<template>

    <div class="box">

      <div @click="back">
        <img src="../assets/exit-2.jpg" class="turn" style="  position: fixed;left: 0px;top: 0px;width: 80px;height:80px;z-index:9999; " id="musicStopIco">
      </div>
    </div>
</template>

<script>
    export default {
        name: "404",
         methods:{
           //返回
           back(){
             this.$router.back();
           },
         }
    }
</script>

<style scoped>

  .box{
    background-image: url("../assets/noCourse.png");
    width: 100%;
    height: 100%;
    background-size: 100% 100%;
    background-attachment: fixed;
  }
</style>



// WEBPACK FOOTER //
// src/views/404.vue